/**
 * Beep sintetizado para alertas Avizor (Web Audio API).
 *
 * Reproduce 3 pitidos consecutivos (880Hz / 1320Hz / 880Hz, ~0.18s cada uno)
 * sin necesidad de un archivo mp3. Pensado para llamar la atención del perito
 * cuando entra una videoperitación inmediata.
 */

let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  } catch {
    return null;
  }
  return audioCtx;
}

/** Reproduce el beep insistente. No-op si el navegador no soporta Web Audio. */
export function playAvizorBeep() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  const beep = (freq, when, dur = 0.18) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, ctx.currentTime + when);
    g.gain.exponentialRampToValueAtTime(0.32, ctx.currentTime + when + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + when + dur);
    o.connect(g);
    g.connect(ctx.destination);
    o.start(ctx.currentTime + when);
    o.stop(ctx.currentTime + when + dur + 0.02);
  };
  beep(880, 0);
  beep(1320, 0.22);
  beep(880, 0.44);
}
